<template>
  <v-dialog :value="isOpenDialog" @click:outside="closeDialog()" max-width="550px">
    <v-card>
      <v-card-title class="pa-0 shadow-1">
        <v-img
          :src="require('@/assets/illustrations/bg_modal_card.svg')"
          cover
          position="left bottom"
          class="align-center"
          height="65px"
        >
          <v-card-title class="font-weight-medium primary--text">
            Importar Citas
          </v-card-title>
        </v-img>
      </v-card-title>
      <v-card-text class="py-5">
        <v-row>
          <!-- Template -->
          <v-col cols="12">
            <v-autocomplete
              filled
              rounded
              :loading="isLoadingTemplates"
              class="rounded-small"
              dense
              label="Plantilla"
              :items="templateList"
              item-text="title"
              item-value="id"
              color="blue-grey"
              v-model="selectedTemplate"
              hide-details
            ></v-autocomplete>
          </v-col>
          <v-col cols="12">
            <v-file-input
              v-model="fileInput"
              truncate-length="15"
              prepend-icon=""
              prepend-inner-icon="mdi-paperclip"
              class="rounded-small"
              filled
              hide-details
              rounded
            ></v-file-input>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="danger" @click="closeDialog" text rounded>
          Cancelar
        </v-btn>
        <v-btn
          color="success"
          class="px-5"
          :disabled="!selectedTemplate || !fileInput"
          @click="submitForm"
          large
          rounded
        >
          Cargar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { PbxHttpClient } from "@/services/httpclient";
export default {
  props: {
    isOpenDialog: { type: Boolean, required: true },
  },

  data() {
    return {
      isLoadingTemplates: false,
      fileInput: null,
      selectedTemplate: null,
      templateList: [],
    };
  },

  created() {
    this.getTemplates();
  },

  methods: {
    closeDialog(forceReload = false) {
      this.$emit("dialog:close", forceReload);
    },

    async getTemplates() {
      this.isLoadingTemplates = true;
      try {
        const { data } = await PbxHttpClient.get("/module_appointment/templates_appointments", {
          params: { page: 1, itemPerPage: 100 },
        });
        this.templateList = data.data;
      } catch (error) {
        console.log(error);
      }
      this.isLoadingTemplates = false;
    },

    async submitForm() {
      this.$store.commit("layout/SET_OVERLAY", {
        value: true,
        title: "Cargando",
      });
      try {
        const payload = new FormData();
        payload.append("file", this.fileInput);
        payload.append("template_id", this.selectedTemplate);
        await PbxHttpClient.post(`/module_appointment/appointments/import`, payload);
        this.$snotify.success("Archivo importado con éxito.", "¡Hecho!");
        this.closeDialog(true);
      } catch (error) {
        // console.log(error);
        this.$snotify.error("Hubo un error cargando las citas.", "¡Error!");
      }
      this.$store.commit("layout/SET_OVERLAY", { value: false, title: "" });
    },
  },
};
</script>

<style></style>
